module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("iVZbQ"))).then(() => parcelRequire('45LbL'));